// extracted by mini-css-extract-plugin
export var checkbox = "_3c-0";
export var circle = "_3c-3";
export var horizontalContainer = "_3c-7";
export var sm = "_3c-5";
export var switch0 = "_3c-2";
export var switchDisabled = "_3c-8";
export var switchEnabled = "_3c-1";
export var textSwitchContainer = "_3c-9";
export var textSwitchOption = "_3c-a";
export var textSwitchOptionSelected = "_3c-b";
export var verticalContainer = "_3c-6";
export var xs = "_3c-4";